var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-item"},[_c(_vm.type,{ref:"component",tag:"component",staticClass:"comp-child",attrs:{"comp-index":_vm.index,"value":_vm.value,"ispreview":true},on:{"change":_vm.timeChange}}),(_vm.isExport)?_c('div',{staticClass:"btn-export",style:({
    left: _vm.position.left+_vm.position.width + 'px',
    top: _vm.position.top + 1 + 'px',
    height: _vm.position.height + 'px'
  })},[(_vm.typeMap[_vm.type])?_c('a-button',{attrs:{"size":"small","type":"primary","ghost":""},on:{"click":_vm.exportClick}},[_c('icon-font',{staticClass:"title-icon",attrs:{"type":"icon-Export"}}),_vm._v(" 导出 ")],1):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }